(function () {
    'use strict';

    angular
      .module('surveyControllers')
      .factory('surveyContextService', service);

    service.$inject = [];

    function service() {
        return {
            IsUpdatingAnswer: false,
            LastUpdatedAnswerTimestamp: null
        };
    }
})();